import React from "react";
import "./matrimonyList.css";

interface PaymentActivationModalProps {
  open: boolean;
  onClose: () => void;
}

const PaymentActivationModal = ({ open, onClose }: PaymentActivationModalProps) => {
  if (!open) return null;

  return (
    <div className='payment-modal-overlay'>
      <div className='payment-modal'>
        <div className='payment-icon'>💍</div>

        <h2>Activate Your Profile</h2>

        <p>Your profile is currently inactive.</p>

        <p>
          Complete your membership payment to activate your profile. Then upload your ID proof and payment receipt in
          the My Profile section to verify your account and enjoy full access to all features. ❤️
        </p>
        <div className='payment-details-box'>
          <h4>Payment Details</h4>

          <div className='payment-row'>
            <span>Payment Amount</span>
            <strong>₨ 25,000.00</strong>
          </div>

          <div className='payment-row'>
            <span>Bank</span>
            <strong>Bank of Ceylon</strong>
          </div>

          <div className='payment-row'>
            <span>Account Name</span>
            <strong>S Abirami</strong>
          </div>

          <div className='payment-row'>
            <span>Account Number</span>
            <strong>6390905</strong>
          </div>

          <div className='payment-row'>
            <span>Branch</span>
            <strong>Milagiriya</strong>
          </div>
        </div>

        <div className='payment-modal-actions'>
          <button className='close-payment-btn' onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentActivationModal;
